/**
 * EVENTUALLY MOVE ME INTO THE @citydna/common package.
 */

import React from "react"
import {
  makeStyles,
  Theme,
  InputLabel as MuiInputLabel,
  InputLabelProps,
} from "@material-ui/core"

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  root: {},
  inputLabel: {
    display: "flex",
    alignItems: "center",
    ...theme.typography.button,
    textTransform: "none",
    marginBottom: theme.spacing(0.5),
    color:
      theme.palette.type === "dark"
        ? theme.palette.grey[50]
        : theme.palette.grey[800],
  },
}))

export const InputLabel: React.FC<InputLabelProps> = props => {
  /** Get scoped CSS classes */
  const classes = useStyles()
  return <MuiInputLabel className={classes.inputLabel} {...props} />
}
